import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { addEventListener } from '@ifeng/ui_base';

class TopicTitle extends React.PureComponent {
    static propTypes = {
        title: PropTypes.string,
    };

    render() {
        const { title } = this.props;

        return (
            <div className={styles.topicTitle}>
                <div className={styles.titleLogo}>
                    <img src="http://p3.ifengimg.com/a/2017/1129/title_logo.png" alt="" />
                </div>
                <div className={styles.titleTxt}>{title}</div>
            </div>
        );
    }
}

export default TopicTitle;
